/**
 * main.js
 *
 * @author
 * @version 1.0.0
 * @copyright 2018 SEDA.digital GmbH & Co. KG
 */

// Dispatch a global event when the main js has been loaded
// this can be used by inlined scripts to know when jQuery is available
window.dispatchEvent(new CustomEvent('jsloaded'));

/**
 * Foundation Framework JS
 *
 * when using any of these, `foundation.core` always needs to be enabled
 * and you need to initialize Foundation (see code below imports)
 */
import { Foundation } from 'foundation-sites/js/foundation.core';
//import { MediaQuery } from 'foundation-sites/js/foundation.util.mediaQuery'; Foundation.plugin(MediaQuery, 'MediaQuery');
import { Keyboard } from 'foundation-sites/js/foundation.util.keyboard'; Foundation.plugin(Keyboard, 'Keyboard');
//import { Abide } from 'foundation-sites/js/foundation.abide'; Foundation.plugin(Abide, 'Abide');
//import { Accordion } from 'foundation-sites/js/foundation.accordion'; Foundation.plugin(Accordion, 'Accordion');
//import { AccordionMenu } from 'foundation-sites/js/foundation.accordionMenu'; Foundation.plugin(AccordionMenu, 'AccordionMenu');
//import { Drilldown } from 'foundation-sites/js/foundation.drilldown'; Foundation.plugin(Drilldown, 'Drilldown');
//import { Dropdown } from 'foundation-sites/js/foundation.dropdown'; Foundation.plugin(Dropdown, 'Dropdown');
//import { DropdownMenu } from 'foundation-sites/js/foundation.dropdownMenu'; Foundation.plugin(DropdownMenu, 'DropdownMenu');
//import { Equalizer } from 'foundation-sites/js/foundation.equalizer'; Foundation.plugin(Equalizer, 'Equalizer');
//import { Interchange } from 'foundation-sites/js/foundation.interchange'; Foundation.plugin(Interchange, 'Interchange');
//import { Magellan } from 'foundation-sites/js/foundation.magellan'; Foundation.plugin(Magellan, 'Magellan');
//import { OffCanvas } from 'foundation-sites/js/foundation.offcanvas'; Foundation.plugin(OffCanvas, 'OffCanvas');
//import { Orbit } from 'foundation-sites/js/foundation.orbit'; Foundation.plugin(Orbit, 'Orbit');
//import { ResponsiveMenu } from 'foundation-sites/js/foundation.responsiveMenu'; Foundation.plugin(ResponsiveMenu, 'ResponsiveMenu');
//import { ResponsiveToggle } from 'foundation-sites/js/foundation.responsiveToggle'; Foundation.plugin(ResponsiveToggle, 'ResponsiveToggle');
//import { Reveal } from 'foundation-sites/js/foundation.reveal'; Foundation.plugin(Reveal, 'Reveal');
//import { Slider } from 'foundation-sites/js/foundation.slider'; Foundation.plugin(Slider, 'Slider');
//import { SmoothScroll } from 'foundation-sites/js/foundation.smoothScroll'; Foundation.plugin(SmoothScroll, 'SmoothScroll');
//import { Sticky } from 'foundation-sites/js/foundation.sticky'; Foundation.plugin(Sticky, 'Sticky');
import { Tabs } from 'foundation-sites/js/foundation.tabs'; Foundation.plugin(Tabs, 'Tabs');
//import { Toggler } from 'foundation-sites/js/foundation.toggler'; Foundation.plugin(Toggler, 'Toggler');
//import { Tooltip } from 'foundation-sites/js/foundation.tooltip'; Foundation.plugin(Tooltip, 'Tooltip');
import { ResponsiveAccordionTabs } from 'foundation-sites/js/foundation.responsiveAccordionTabs'; Foundation.plugin(ResponsiveAccordionTabs, 'ResponsiveAccordionTabs');

// Init Foundation
Foundation.addToJquery(jQuery); // this and the next line need to be enabled when using foundation JS
$(document).foundation();

// Import Components
//import Example from './components/example.js';
//new Example();

// custom components
import { FormHandler } from './components/_formhandler.js';
import { mobileNav } from './components/_mobile-nav.js';
import { card } from './components/_card.js';
import { custAccordion } from './components/_accordion.js';
import { slider } from './components/_slider.js';
import { modalToApi } from './components/_api-modals';
//import { ProgressBar }  from './components/_progress-bar.js';
import { DatePicker } from './components/_datepicker.js';
import UploadImages from './components/_filepond.js';
let mediauploadService = new UploadImages();
mediauploadService.init($('[data-mediaupload]'));
import Bookmarks from './components/_bookmarks.js';
import Readmore from './components/_readmore.js';
import AnchorScroll from './components/_anchor-scroll.js'
import Gallery from './components/_gallery.js'
new Gallery().init();

import TextEditor from './components/_easymde.js';
new TextEditor();

import Workshops from './components/_workshops.js';
import UserStatistics from './components/_statistic-user.js';
import CompanyStatistics from './components/_statistic-company.js';
import UserApplications from './components/_user-applications.js';
import UserAppointments from './components/_user-appointments.js';

import Jobs from './components/_jobs.js';
let jobResults = document.querySelectorAll('[data-joblistsource]');
if (jobResults.length > 0) {
    jobResults.forEach(el => {
        let jobResults = new Jobs().init(el);
    });
}

import Api from './components/_api';
if (window.siteconfig.resource.id === 27) {
    // job detail page
    Api.request('POST', 'track', {
        'type': 'job_view',
        'targetid': window.siteconfig.job.id
    })
        .then(function (response) {
            console.log('job view acknowledged');
        })
        .catch(function (exception) {
            let error_message = 'Unbekannter Fehler';
            if (typeof exception === 'object'
                && typeof exception.responseJSON === 'object'
                && typeof exception.responseJSON.error_code !== 'undefined'
                && typeof exception.responseJSON.error_message === 'string'
            ) {
                error_message = exception.responseJSON.error_message;
            }
            console.error('Could not track job view: ' + error_message);
        });
}

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *	Modal Settings (http://www.humaan.com/modaal/)
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
$('.gallery-image').modaal({
    type: 'image',
    close_text: 'Schließen',
    close_aria_label: 'Schließen (Escape Taste drücken zum schließen)',
    confirm_button_text: 'OK',
    confirm_cancel_button_text: 'Abbrechen',
    loading_content: 'Lade &hellip;'
});

$(".c-sharing-modal-link").modaal(
    {
        close_text: 'Schließen',
        close_aria_label: 'Schließen (Escape Taste drücken zum schließen)',
        background: '#fff',
        width: 400,
        background_scroll: false
    }
);

window.trackGAEvent = function trackGAEvent(category, action, label) {
    if (typeof category === 'undefined') return;
    if (typeof action === 'undefined') return;

    console.log('Sending GA Event: ' + action);

    let data = {};
    if (typeof window.gtag === 'function') {
        data = {
            'event_category': category
        };
        if (typeof label !== 'undefined') data.event_label = label;
        window.gtag('event', action, data);

    } else {
        console.warn('Could not send GA event');
    }
}

// replace queue with now available function
window.e = window.trackGAEvent;

// process queue (see queue setup in `tpl.head`)
$.each(window.equeue, function (i, item) {
    window.trackGAEvent(item[0], item[1], item[2]);
});
